
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"9f9fc4146364a567f60bcb9a111c3da81282ed1d":"$$ACTION_0","e02e25ccce5e5b553a3a541d8ae2a9e6e73dedf3":"getServerMetrics"} */ export var getServerMetrics = createServerReference("e02e25ccce5e5b553a3a541d8ae2a9e6e73dedf3");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

